// src/components/Profile.js
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import {
    Box,
    Typography,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    Alert,
    Container,
    Stack,
    Avatar,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

function Profile(props) {
    const history = useHistory();
    const location = useLocation();
    const user = location.state?.user; // Access user data passed via useLocation
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        first_name: '',
        last_name: '',
        date_of_birth: '',
        gender: '',
        mobile: '',
    });
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const { visible, setVisible } = props;
    const [profilePicFile, setProfilePicFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);


    // Populate formData when user is available
    useEffect(() => {
        setVisible(false);
        if (!user) {
            // If user data is not passed, redirect to login
            history.push('/login');
            return;
        }

        setFormData({
            email: user.email || '',
            first_name: user.first_name || '',
            last_name: user.last_name || '',
            date_of_birth: user.date_of_birth ? user.date_of_birth.split('T')[0] : '',
            gender: user.gender || '',
            mobile: user.mobile || '',
        });
    }, [user, history]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setProfilePicFile(file);
        if (file) {
            setPreviewUrl(URL.createObjectURL(file)); // preview image
            if (profilePicFile) {
                // console.log('profilePicFile', profilePicFile);
                setFormData("profile_pic", profilePicFile);
            }
        }
    };

    const handleEdit = () => {
        setIsEditing(true);
        setError(null);
        setSuccess(null);
    };

    const handleCancel = () => {
        setIsEditing(false);
        setError(null);
        setSuccess(null);
        setFormData({
            email: user.email || '',
            first_name: user.first_name || '',
            last_name: user.last_name || '',
            date_of_birth: user.date_of_birth ? user.date_of_birth.split('T')[0] : '',
            gender: user.gender || '',
            mobile: user.mobile || '',

        });
        setProfilePicFile(null);
        setPreviewUrl(user.profile_pic_url || null);
    };

    const profileEditUrl = (process.env.REACT_APP_SERVER) ? `https://salonserver-k8m8.onrender.com/users` : `http://localhost:3001/users`
    // console.log('user.id', user?.id);
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const token = localStorage.getItem('token');
            if (!token || !user?.id) {
                throw new Error('Authentication required');
            }
            const formPayload = new FormData();
            Object.keys(formData).forEach((key) => {
                formPayload.append(key, formData[key]);
            });

            if (profilePicFile) {
                formPayload.append("profile_pic", profilePicFile);
            }
            // console.log('formpayload', formPayload);
            for (let pair of formPayload.entries()) {
                // console.log(pair[0] + ": ", pair[1]);
            }

            const response = await axios.put(
                `${profileEditUrl}/${user.id}`,
                formPayload,
                {
                    headers: { Authorization: `${token}` },
                }
            );

            // Since we're not managing user state in Profile, redirect to refresh user data
            // console.log('Profile updated:', response.data);
            history.push('/profile', { user: response.data });
            setIsEditing(false);
            setSuccess('Profile updated successfully!');
            setError(null);
        } catch (err) {
            console.error('Failed to update profile:', err);
            setError('Failed to update profile. Please try again.');
            setSuccess(null);
        }
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     try {
    //         const token = localStorage.getItem("token");

    //         if (!token) {
    //             throw new Error("No token found");
    //         }

    //         const formPayload = new FormData();

    //         // 🔥 Rails expects all fields under: user[field]
    //         Object.keys(formData).forEach((key) => {
    //             formPayload.append(`user[${key}]`, formData[key]);
    //         });

    //         // 🔥 profile_pic is NOT nested inside user
    //         if (profilePicFile) {
    //             formPayload.append("profile_pic", profilePicFile);
    //         }

    //         const response = await axios.put(
    //             `${profileEditUrl}/${user.id}`,
    //             formPayload,
    //             {
    //                 headers: {
    //                     Authorization: token,
    //                     "Content-Type": "multipart/form-data",
    //                 },
    //             }
    //         );

    //         console.log("Profile updated:", response.data);

    //         setSuccess("Profile updated successfully!");
    //         setError(null);
    //         setIsEditing(false);

    //     } catch (err) {
    //         console.error("Failed to update profile:", err);
    //         setError("Failed to update profile. Please try again.");
    //         setSuccess(null);
    //     }
    // };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     try {
    //         const token = localStorage.getItem("token");

    //         const formPayload = new FormData();

    //         // Wrap all fields under user[...] because Rails requires params[:user]
    //         Object.keys(formData).forEach((key) => {
    //             formPayload.append(`user[${key}]`, formData[key]);
    //         });

    //         // Attach profile pic outside user params
    //         if (profilePicFile) {
    //             formPayload.append("profile_pic", profilePicFile);
    //         }

    //         const response = await axios.put(
    //             `${profileEditUrl}/${user.id}`,
    //             formPayload,
    //             {
    //                 headers: {
    //                     Authorization: `${token}`,
    //                     "Content-Type": "multipart/form-data",
    //                 },
    //             }
    //         );

    //         console.log("Profile updated:", response.data);
    //         history.push("/profile", { user: response.data });
    //         setIsEditing(false);
    //         setSuccess("Profile updated successfully!");
    //         setError(null);

    //     } catch (err) {
    //         console.error("Failed to update profile:", err);
    //         setError("Failed to update profile. Please try again.");
    //         setSuccess(null);
    //     }
    // };



    if (!user) {
        return (
            <Container maxWidth="sm" sx={{ py: 4 }}>
                <Typography variant="body1" color="textSecondary">
                    Loading profile...
                </Typography>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm" sx={{ py: 4 }}>
            <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
                Your Profile
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>

                <Avatar
                    src={previewUrl || user?.profile_pic_url}
                    // src={user?.profile_pic_url}
                    sx={{ bgcolor: "#1976d2", width: 100, height: 100 }}>
                    {user?.profile_pic_url}
                    {/* {console.log('user in Profile:', user?.profile_pic_url)} */}

                </Avatar>
            </Box>

            <Button variant="outlined" component="label">
                Change Photo
                <input type="file" hidden accept="image/*" onChange={handleImageChange} />
            </Button>

            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}
            {success && (
                <Alert severity="success" sx={{ mb: 2 }}>
                    {success}
                </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                <Stack spacing={2}>
                    <TextField
                        label="Email can not be changed"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        fullWidth
                        variant="outlined"
                        InputProps={{
                            readOnly: true,
                        }}
                    />

                    <TextField
                        label="First Name"
                        name="first_name"
                        type="text"
                        value={formData.first_name}
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        fullWidth
                        variant="outlined"
                        InputProps={{
                            readOnly: !isEditing,
                        }}
                    />

                    <TextField
                        label="Last Name"
                        name="last_name"
                        type="text"
                        value={formData.last_name}
                        onChange={handleChange}
                        disabled={!isEditing}
                        fullWidth
                        variant="outlined"
                        InputProps={{
                            readOnly: !isEditing,
                        }}
                    />

                    <TextField
                        label="Date of Birth"
                        name="date_of_birth"
                        type="date"
                        value={formData.date_of_birth}
                        onChange={handleChange}
                        disabled={!isEditing}
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            readOnly: !isEditing,
                        }}
                    />

                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Gender</InputLabel>
                        <Select
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                            disabled={!isEditing}
                            label="Gender"
                        >
                            <MenuItem value="">Select Gender</MenuItem>
                            <MenuItem value="female">Female</MenuItem>
                            <MenuItem value="male">Male</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        label="Mobile"
                        name="mobile"
                        type="tel"
                        value={formData.mobile}
                        onChange={handleChange}
                        disabled={!isEditing}
                        fullWidth
                        variant="outlined"
                        inputProps={{
                            pattern: '[0-9]{10}',
                        }}
                        helperText={isEditing ? 'Enter a 10-digit mobile number' : ''}
                        InputProps={{
                            readOnly: !isEditing,
                        }}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                        {isEditing ? (
                            <>
                                <Button
                                    type="button"
                                    onClick={handleCancel}
                                    variant="outlined"
                                    color="secondary"
                                    startIcon={<CancelIcon />}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    startIcon={<SaveIcon />}
                                >
                                    Save
                                </Button>
                            </>
                        ) : (
                            <Button
                                type="button"
                                onClick={handleEdit}
                                variant="contained"
                                color="primary"
                                startIcon={<EditIcon />}
                            >
                                Edit Profile
                            </Button>
                        )}
                    </Box>
                </Stack>
            </Box>
        </Container>
    );
}

export default Profile;